var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcHportrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BCHportrait",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 133,
    viewBox: "0 0 100 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1331",
    "data-name": "Rectangle 1331",
    width: 100,
    height: 133,
    fill: "#68759c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M50,66.5A22.85,22.85,0,1,0,27.1,43.6,22.9,22.9,0,0,0,50,66.5Zm9.1,8.6H40.9A30.92,30.92,0,0,0,10,106a6.231,6.231,0,0,0,6.2,6.2H83.8A6.231,6.231,0,0,0,90,106,30.92,30.92,0,0,0,59.1,75.1Z",
    fill: "#536798"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M39.6,51.5h3c1.5,0,2.6.8,2.6,2.2a1.981,1.981,0,0,1-1,1.8h0a1.956,1.956,0,0,1,1.3,2c0,1.7-1.3,2.4-2.9,2.4h-3V51.5Zm3,3.4a.972.972,0,0,0,1-1.1c0-.6-.3-1-1.1-1H41v2.1Zm.2,3.6a1.2,1.2,0,0,0,0-2.4H41.2v2.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M49.6,53.7a3.125,3.125,0,0,1,3.3,3.2,3.182,3.182,0,0,1-3.3,3.2,3.125,3.125,0,0,1-3.3-3.2A3.072,3.072,0,0,1,49.6,53.7Zm0,5a1.76,1.76,0,0,0,1.8-1.9,1.8,1.8,0,1,0-3.6,0A1.71,1.71,0,0,0,49.6,58.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M54,58.1a2.551,2.551,0,0,0,1.6.7c.4,0,.8-.2.8-.6,0-.9-2.9-.8-2.9-2.7,0-1.1,1-1.8,2.3-1.8a2.944,2.944,0,0,1,2,.7l-.6,1.1a2.522,2.522,0,0,0-1.5-.5c-.4,0-.8.2-.8.6,0,.9,2.9.7,2.9,2.7,0,1-.9,1.8-2.3,1.8a3.2,3.2,0,0,1-2.3-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M59.3,55.1h-.8V53.9h.8V52.2h1.5v1.7h1.4v1.2H60.8v2.3A1.048,1.048,0,0,0,62,58.5h.3v1.3h-.5a2.252,2.252,0,0,1-2.5-2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M66.1,53.7a3.125,3.125,0,0,1,3.3,3.2,3.182,3.182,0,0,1-3.3,3.2,3.125,3.125,0,0,1-3.3-3.2A3.182,3.182,0,0,1,66.1,53.7Zm0,5a1.76,1.76,0,0,0,1.8-1.9,1.8,1.8,0,1,0-1.8,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M70.3,53.8h1.4v1.1h0a2.386,2.386,0,0,1,2.1-1.3c1.3,0,2.1.7,2.1,2.3v3.9H74.4V56.2c0-.7-.2-1.2-1-1.2a1.621,1.621,0,0,0-1.6,1.2,2.2,2.2,0,0,0-.1.8v2.8H70.2v-6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M43.2,61.7a4.577,4.577,0,0,1,3.1,1.1l-.7,1.1a3.828,3.828,0,0,0-2.3-.9,2.7,2.7,0,0,0-2.8,2.9,2.842,2.842,0,0,0,2.8,3,3.316,3.316,0,0,0,2.4-1.1l.8,1.1a4.72,4.72,0,0,1-3.3,1.3,4.174,4.174,0,0,1-4.3-4.4A4.1,4.1,0,0,1,43.2,61.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M47.6,61.8h1.5v3.4h0A2.269,2.269,0,0,1,51.2,64c1.3,0,2.1.7,2.1,2.3v3.9H51.8V66.6c0-.7-.2-1.2-1-1.2a1.6,1.6,0,0,0-1.6,1.3,1.949,1.949,0,0,0-.1.8v2.8H47.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M63,64a1.815,1.815,0,0,1,1.7.8h0V61.9h1.5v8.4H64.8v-.9h0a2.09,2.09,0,0,1-1.9,1c-1.6,0-2.7-1.3-2.7-3.2C60.3,65.3,61.4,64,63,64Zm.3,5.1c.8,0,1.5-.6,1.5-1.9,0-1-.5-1.9-1.5-1.9-.8,0-1.5.7-1.5,1.9C61.8,68.3,62.4,69.1,63.3,69.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M67.7,64.2h1.4v1.4h0A2.113,2.113,0,0,1,71,64h.3v1.5H71a1.556,1.556,0,0,0-1.6,1.3,3.083,3.083,0,0,0-.1,1v2.4H67.8l-.1-6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M74.7,64a2.679,2.679,0,0,1,2.7,2.9v.6H73.2A1.751,1.751,0,0,0,75,69.1a2.632,2.632,0,0,0,1.7-.7l.6,1.1a3.593,3.593,0,0,1-2.4.9,3.125,3.125,0,0,1-3.3-3.2A3.077,3.077,0,0,1,74.7,64Zm1.2,2.4a1.184,1.184,0,0,0-1.2-1.3,1.344,1.344,0,0,0-1.4,1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M78.5,64.2h1.4v1.1h0A2.386,2.386,0,0,1,82,64c1.3,0,2.1.7,2.1,2.3v3.9H82.6V66.6c0-.7-.2-1.2-1-1.2A1.621,1.621,0,0,0,80,66.6v3.7H78.5V64.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M86.1,68.4a2.551,2.551,0,0,0,1.6.7c.4,0,.8-.2.8-.6,0-.9-2.9-.8-2.9-2.7,0-1.1,1-1.8,2.3-1.8a2.944,2.944,0,0,1,2,.7l-.6,1.1a2.522,2.522,0,0,0-1.5-.5c-.4,0-.8.2-.8.6,0,.9,2.9.7,2.9,2.7,0,1-.9,1.8-2.3,1.8a3.2,3.2,0,0,1-2.3-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M39.6,72.1h1.5v3.6H45V72.1h1.5v8.4H45V77H41.1v3.5H39.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M50.9,74.4a3.125,3.125,0,0,1,3.3,3.2,3.182,3.182,0,0,1-3.3,3.2,3.125,3.125,0,0,1-3.3-3.2A3.182,3.182,0,0,1,50.9,74.4Zm0,5a1.76,1.76,0,0,0,1.8-1.9,1.8,1.8,0,1,0-1.8,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M55.4,78.7a2.551,2.551,0,0,0,1.6.7c.4,0,.8-.2.8-.6,0-.9-2.9-.8-2.9-2.7,0-1.1,1-1.8,2.3-1.8a2.944,2.944,0,0,1,2,.7l-.6,1.1a2.522,2.522,0,0,0-1.5-.5c-.4,0-.8.2-.8.6,0,.9,2.9.7,2.9,2.7,0,1-.9,1.8-2.3,1.8a3.2,3.2,0,0,1-2.3-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M60.3,74.5h1.4v.8h0a2.166,2.166,0,0,1,2-1c1.6,0,2.7,1.3,2.7,3.2a2.908,2.908,0,0,1-2.8,3.2,2.008,2.008,0,0,1-1.7-.8h0v3H60.4V74.5Zm2.9,4.9c.8,0,1.5-.7,1.5-1.9,0-1.1-.6-1.9-1.5-1.9-.8,0-1.5.6-1.5,1.9C61.7,78.5,62.2,79.4,63.2,79.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M70.5,75.8h-.8V74.6h.8V72.9H72v1.7h1.4v1.2H72v2.3a1.048,1.048,0,0,0,1.2,1.1h.3v1.3H73a2.252,2.252,0,0,1-2.5-2.3V75.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M77.8,76.7H78v-.1c0-.8-.5-1.1-1.2-1.1a2.736,2.736,0,0,0-1.6.6L74.6,75a4.552,4.552,0,0,1,2.4-.7,2.238,2.238,0,0,1,2.5,2.4v3.8H78.1v-.9h0a2.018,2.018,0,0,1-1.8,1.1,1.864,1.864,0,0,1-2-1.9C74.3,76.9,76.8,76.7,77.8,76.7Zm-1.1,2.8c.8,0,1.3-.9,1.3-1.6v-.1h-.3c-.8,0-2,.1-2,1C75.7,79.1,76,79.5,76.7,79.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M57.8,70.2V61.8h1.5v8.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M80.8,80.5V72.1h1.5v8.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M86.1,62.6a.8.8,0,0,1-1.6,0,.8.8,0,0,1,1.6,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M84.8,64.1l-.1-.5c1.1-.3.9-1,.9-1.1l.5-.1S86.4,63.7,84.8,64.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M54.7,64.2h1.5v6H54.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M56.3,62.6a.8.8,0,1,1-1.6,0,.86.86,0,0,1,.8-.8C55.9,61.7,56.3,62.1,56.3,62.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M67.2,74.5h1.5v6H67.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M68.9,72.9a.8.8,0,1,1-.8-.8A.789.789,0,0,1,68.9,72.9Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M22.7,50.1c-7,0-12.7,7.2-12.7,16.1s5.7,16.1,12.7,16.1S35.3,75,35.3,66.2,29.6,50.1,22.7,50.1Zm0,31.4c-6.5,0-11.9-6.9-11.9-15.3s5.3-15.3,11.9-15.3,11.9,6.9,11.9,15.3S29.2,81.5,22.7,81.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M25.2,56.1a17.482,17.482,0,0,0,2.9,1.8,6.713,6.713,0,0,1,1.5-.6v-.1c-1-.6-2-1.2-2.9-1.7h0v1.2a6.706,6.706,0,0,1-1.4-.9h0c0-.1.1-.1.2-.1.3-.1.7-.2,1-.3v-.1l-2.9-2.4-.2-.1c0,.5-.1,1-.1,1.5a.349.349,0,0,0-.1.2A17.489,17.489,0,0,0,25.2,56.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M29.3,56.8a27.18,27.18,0,0,0-2.4-2.4l-3.1-1.6h-.1A17.41,17.41,0,0,1,25.1,54,16.212,16.212,0,0,0,29.3,56.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M30.7,66.4c0-1.3-1.3-1.7-2-2.5-.2-.1-.3.1-.5,0-.3-.2.2-.2.2-.4-.3-.4-.3-.9-.6-1.3-.2-.1-.3.1-.5,0a4.923,4.923,0,0,0-.6-1.7c-.7-.4-.7.7-1.3.6V61c0-.1.1-.1.2-.2s.1-.4.1-.6c-.1-.2-.3-.2-.5-.2-.1,0-.1-.1-.1-.2.2-.3.5,0,.8,0,.3-.2.6-.1.9-.2a.55.55,0,0,0,.3-.5h.3a.6.6,0,0,0-.1-.4c-1-.5-1.7-1.4-2.8-1.7-.2-.1-.6,0-.5-.3-.1-.3-.5-.3-.8-.4v-.4c-.3-.1-.5-.5-.7-.8a1.854,1.854,0,0,0-.7-.2c-.6,0-.6.8-1,1.1-.1.2-.4.4-.4.7.1.4.7.5,1.1.6a.749.749,0,0,0,.5-.1c0-.1,0-.1-.1-.1a.192.192,0,0,1-.1-.3c.1-.1.2-.1.4-.1.2.2.4-.1.7,0,.2,0,.3.3.4.5-.3,0-.6-.2-.9-.1-.1.1,0,.3,0,.4a1.268,1.268,0,0,0,.6-.1c.1,0,.2,0,.3.2a3.1,3.1,0,0,1,1.7.5c0,.2.3.3.1.5a2.213,2.213,0,0,0-2.2-.5c-.1-.1,0-.3-.1-.3a7.838,7.838,0,0,0-1.4.5h.1v-.2c-.1,0-.2-.1-.3-.1-.2.3.1.7.1,1,.1.4.3-.1.6,0,.2,0,.4-.1.6,0-.2.1-.5.1-.7.3v.2c.2.3.6.1.9.2a.31.31,0,0,1-.1.2c-.3,0-.5.3-.7.6-.2,0-.1-.3-.1-.4s-.2-.1-.3-.1c-.1.4-.2.7-.3,1,0,.2.3.1.5.2.2,0,.1.3.2.5h.7v.2a.52.52,0,0,1-.4.2.219.219,0,0,0-.1.3c.4.2,0,.8.3,1a1.928,1.928,0,0,0,1.3,0c.2,0,.4-.3.7-.2a.1.1,0,0,1,.1.1,8.083,8.083,0,0,0,1.6-.1c.2,0,.4-.1.5,0v.1a9.27,9.27,0,0,1-2.4.4c-.5.1-.3.7-.3,1.1-.3.1-.2-.3-.4-.4a7.173,7.173,0,0,0-2.1.5,1.742,1.742,0,0,0-.8,1.2c0,.3-.1.6.1.7a2.108,2.108,0,0,0,1.9-.1c.4-.1.8-.5,1.3-.3a2.41,2.41,0,0,1,1-1c.2,0,.2-.3.4-.3s.1.3.1.3a4.819,4.819,0,0,1,1.2,0,.55.55,0,0,1,.3.5v.3c.1.3-.2.4,0,.8a3.363,3.363,0,0,1-2.1,1.6c-.2.1,0,.4-.2.5-1,.7-2.6,1-2.9,2.4-.2.7.4,1,.9,1.3.6.1.9.9,1.6.7a20.156,20.156,0,0,1,.7-2.3,15.661,15.661,0,0,1,3.2-4,2.751,2.751,0,0,1,1.5-.8c.1,0,0,.1,0,.1a4.826,4.826,0,0,0-1.4.9,4,4,0,0,0-1,1.2,19.571,19.571,0,0,0-2,3,4.033,4.033,0,0,0,0,1.1c.1,0,.1-.1.2-.2.5-1,1-2,1.6-3a3.039,3.039,0,0,1,1.2-1.3h0a16.924,16.924,0,0,0-1.7,2.9,10.639,10.639,0,0,0-.9,2.5c.1.2.4.1.6.3.1.1.2.3.1.4,0,.1-.1.2-.3.2s-.2-.3-.3-.5c-.1,0-.2-.1-.2,0,0,.3.3.7,0,1-.3.2-.2-.2-.4-.3h-.3a6.173,6.173,0,0,1-3.3,1.4c-.4.2-1.2-.1-1.2.5s0,1.3.4,1.6a10.925,10.925,0,0,0,3.6-.2,9.889,9.889,0,0,0,2.4-.9c1.2-.9,1.8-2.4,2.5-3.6C30.3,71,31.1,68.8,30.7,66.4ZM25,58.6a2.7,2.7,0,0,0,1.5.3c.1,0,.2,0,.2.1s0,.2-.1.2c-.7.2-1.1-.2-1.6-.6Zm-1.1.2c-.4-.1-.9-.3-1-.7v-.2a1.909,1.909,0,0,0,1.6.6s.2.1.1.2a.367.367,0,0,0-.3.1c.2.5.8.6,1.3.8,0,.1,0,.1-.1.1A1.893,1.893,0,0,1,23.9,58.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M27.2,58.4c.1,0,.3.1.4,0s0-.2,0-.3A29.715,29.715,0,0,1,23,54.8h-.2v.3A23,23,0,0,0,27.2,58.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M26.9,60.4v.1a1.232,1.232,0,0,0,1,.2,1.832,1.832,0,0,0,.6-1.7c0-.1-.2-.2-.3-.2-.2-.1-.4,0-.6.2,0,.3-.5.3-.4.7-.1.2-.3.2-.4.3v.2c.3,0,.5.2.8.1.1,0,.1.1.1.2C27.5,60.5,27.2,60.4,26.9,60.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M16.6,63.8c.5-.2-.2-.5,0-.9.3,0,.2.3.4.4.2,0,.3-.2.4-.2.3.1.1.5.3.7a1.88,1.88,0,0,0,1.7.8c.5,0,.7-.4,1-.8.1-.5.3-1.2,0-1.6-.1-.1-.3.1-.4,0a.622.622,0,0,1,.4-.6,1.128,1.128,0,0,0-.1-.8.349.349,0,0,1,.2-.1,1.277,1.277,0,0,0-.2-1.2c-.2,0-.3-.2-.5-.1h0c-.1,0-.4-.1-.5,0a3.81,3.81,0,0,0-1-.3,2.1,2.1,0,0,0-1.5.5c-1,.5-.7,1.7-1.2,2.5a1.625,1.625,0,0,0,.3,1.5C16.1,63.6,16.3,63.9,16.6,63.8Zm3.4,0c0,.1-.1.1-.3.1-.1,0-.2-.2-.4-.1v-.1c.2.1.3-.1.6-.1a.139.139,0,0,1,.2,0C20.1,63.7,20,63.7,20,63.8Zm.1-.7c.1.1-.1.2-.2.2s-.1-.1-.2-.2C19.8,63,20,63.1,20.1,63.1ZM19.6,61c.2-.2.1-.6.3-.8.1,0,.2,0,.2.1v.4c-.4,0-.2.7-.7.5l-.1-.1C19.4,60.9,19.5,61.1,19.6,61Zm-.1,1.1a.6.6,0,0,1-.1.4h-.7c0-.3.5-.2.3-.5h-.2c0-.1.1-.1.1-.2C19.1,61.9,19.5,61.8,19.5,62.1Zm-1.8-.5a.192.192,0,0,0,.3-.1c.1-.1.2-.5.4-.5a.192.192,0,0,0,.3.1h.1c0,.2-.1.3-.3.4-.2,0-.3-.1-.4.1,0,.2,0,.4-.2.5-.1,0-.3-.2-.3,0v.6h-.2A2.279,2.279,0,0,1,17.7,61.6ZM16.4,61c.2,0,.2.3.5.1a2.2,2.2,0,0,1-.1.8c-.2,0,0-.3-.2-.5-.3.2-.1.7-.4.9a.1.1,0,0,1-.1-.1C16.2,61.9,16.1,61.4,16.4,61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M16.9,75.1c.9-.5,1.7.2,2.6.1,1-.4,2.2-.5,3.2-.9.2-.1.6-.1.7-.4a4.671,4.671,0,0,0-.5-1c-.4-.5-1-.4-1.6-.6-.7-.3-.7.6-1.2.6-.1,0-.2-.2-.2-.3.1-.3.5-.4.7-.7a1.068,1.068,0,0,0-.3-1.1c-.1-.3.4-.6.1-.8-.6,0-1,.5-1.6.8-.1,0-.2.1-.3,0a2.047,2.047,0,0,1,.8-.8v-.1h0c-.7.1-1-.5-1.5-.8-.2-.1-.4,0-.6-.1a.6.6,0,0,1,.1-.4c.9,0,1.5,1.1,2.4.6a2.655,2.655,0,0,0,2.8-.6c.3-.1.6-.4.9-.2.3,0,.5-.2.8-.4a5.663,5.663,0,0,0-.3-1.8c-.1-.1-.2-.3-.4-.2a4.394,4.394,0,0,1-2.2.7c-.2,0,.1.2,0,.3h-.1l-1.1-1a6.071,6.071,0,0,1-1-.7c0-.5-.6-.2-.8-.4l-.3-.2c-.4,0-.5-.6-.9-.5a1.765,1.765,0,0,1-.9.8c-.9.5-.7,1.6-1.1,2.5-.3,1.8-1.2,3.8-.4,5.8.5.3.3,1,.7,1.3A2.7,2.7,0,0,0,16.9,75.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M26.4,64.8c-.4-.1-.7.1-1,.1-.2,0-.3-.1-.4,0a1.482,1.482,0,0,0-.8,1.2c.2.3.3.7.7.8a1.984,1.984,0,0,0,1.6-1,1.949,1.949,0,0,0,.1-.8c0-.1-.1-.1-.1-.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M19.6,77.3a1.627,1.627,0,0,0-.1-1.2c-.3-.2-.7-.4-1-.6-.5-.1-1.2-.4-1.6.1-.3.1-1,.1-1,.6,0,.2.3.3.2.5,0,.1.3.1.3.3,0,.3.4.3.5.6a1.077,1.077,0,0,0,.8.2A10.549,10.549,0,0,0,19.6,77.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M27,76.8c-.1,0-.1.1-.1.2a8.777,8.777,0,0,0,1.2,1.5,1.344,1.344,0,0,0,.7-.6C28.3,77.4,27.8,76.7,27,76.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M25.1,77.7a8.1,8.1,0,0,0-1.3.6,6.254,6.254,0,0,1-2.3-.1,5.7,5.7,0,0,0-1.3.1c-.3.1-.5.3-.8.3a1.579,1.579,0,0,1-.7,0c-.3,0-.7-.2-1-.2-.2,0-.3.3-.4.5a8.622,8.622,0,0,0,7.5,1.2,2.471,2.471,0,0,0,.9-.4,10.26,10.26,0,0,1-.4-1.4C25.3,78,25.4,77.7,25.1,77.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M27,77.8h-.2c-.3.3-1-.2-1,.4a2.541,2.541,0,0,0,.5,1.3,1.08,1.08,0,0,0,.7-.3c0-.3-.3-.4-.2-.7.3,0,.4.3.6.4a.319.319,0,0,0,.3-.3C27.6,78.3,27.3,78.2,27,77.8Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcHportrait);
export default __webpack_public_path__ + "static/media/BCHportrait.1496ee4e07fecfd8b0b3cf978e8df8a7.svg";
export { ForwardRef as ReactComponent };